import "./error.css";

interface ErrorProps {
  label: string;
  icon: string;
  icon2?: string;
  backgroudError: string;
  colorError: string;
  id?: string;
  widthError: string;
  onClose?: () => void;
  classAuxiliar?: any;
}

export const ContainerError = ({
  label,
  icon,
  icon2,
  backgroudError,
  colorError,
  widthError,
  onClose,
  classAuxiliar,
  id,
}: ErrorProps) => {
  return (
    <div
      id={id}
      data-testid="error-container"
      className={`containerErro containerErroSmall errorAbs ${classAuxiliar}`}
      style={{
        backgroundColor: backgroudError,
        color: colorError,
        width: widthError,
      }}
    >
      <img src={icon} alt="icone" className="iconErro" />
      <span className="labelErro">{label}</span>
      {icon2 && (
        <button
          type="button"
          onClick={onClose}
          style={{
            background: "none",
            border: "none",
            padding: 0,
          }}
          aria-label="Fechar alerta"
        >
          <img
            src={icon2}
            alt="Fechar alerta"
            className="CloseIconErro"
          />
        </button>
      )}
    </div>
  );
};

export default ContainerError;
